import { httpGet, httpPut } from '../../Util/http';
import { routeActions } from 'redux-simple-router';
import { addAlert } from '../../MsgNotify/msgNotifyActions';
import 'isomorphic-fetch';

export const FETCH_PROJECTS_REQUEST = 'FETCH_PROJECTS_REQUEST';
export const fetchProjectsRequest = () =>{
    return {
        type: FETCH_PROJECTS_REQUEST
    }
}

export const FETCH_PROJECTS_SUCCESS = 'FETCH_PROJECTS_SUCCESS';
export const fetchProjectsSuccess = (json) =>{
    return {
        type: FETCH_PROJECTS_SUCCESS,
        projects: json.projects
    }
}

export const FETCH_PROJECTS_SUCCESS_INIT = 'FETCH_PROJECTS_SUCCESS_INIT';
export const fetchProjectsSuccessInit = (json) =>{
    return {
        type: FETCH_PROJECTS_SUCCESS_INIT,
        projects: json.projects
    }
}


export const FETCH_PROJECTS_FAILURE = 'FETCH_PROJECTS_FAILURE';
export const fetchProjectsFailure = () =>{
    return {
        type: FETCH_PROJECTS_FAILURE
    }
}

export const SET_SHOW_FAVORITES = 'SET_SHOW_FAVORITES';
export const setShowFavorites = (showFavorites) =>{
    return {
        type: SET_SHOW_FAVORITES,
        showFavorites: showFavorites
    }
}



export function fetchProjects(isInit){
    //api/projects
    return (dispatch, getState) => {
        let skip = getState().projectDashboardReducer.projects.length;
        let showFavorites = getState().projectDashboardReducer.showFavorites;
        if(isInit)
            skip = 0
        let _url = process.env.REACT_APP_webApiEndPoint + `api/project?skip=${skip}&take=9&showAll=${!showFavorites}`;
        dispatch(fetchProjectsRequest());
        return httpGet(_url)
        .then(response => {
            return response.json();
        })
        .then(json => {
            if(isInit)
                dispatch(fetchProjectsSuccessInit(json))
            else
                dispatch(fetchProjectsSuccess(json))
        })
        .catch((e) => {
                    //TODO pushpath to previous kanban overview
            dispatch(routeActions.push('/tilbud'));
            dispatch(fetchProjectsFailure);
            dispatch(addAlert(e.message))
        })
    };
}


export const EDIT_CONTACT_REQUEST = 'EDIT_CONTACT_REQUEST';
export const editContactRequest = (projectIndex, contact, contactIndex) =>{
    return {
        type: EDIT_CONTACT_REQUEST,
        projectIndex: projectIndex,
        contact: contact,
        contactIndex: contactIndex
    }
}

export const EDIT_CONTACT_SUCCESS = 'EDIT_CONTACT_SUCCESS';
export const editContactSuccess = () =>{
    return {
        type: EDIT_CONTACT_SUCCESS
    }
}

export const EDIT_CONTACT_FAILURE = 'EDIT_CONTACT_FAILURE';
export const editContactFailure = (projectIndex, contact, contactIndex) =>{
    return {
        type: EDIT_CONTACT_FAILURE,
        projectIndex: projectIndex,
        contact: contact,
        contactIndex: contactIndex
    }

}

export function editContact(projectIndex, projectId, contact, oldContact, contactIndex){
    var _url = process.env.REACT_APP_webApiEndPoint + "api/project/"+projectId+"/editContact";
    return dispatch => {
        dispatch(editContactRequest(projectIndex, contact, contactIndex));
        return httpPut(_url, contact)
        .then(() => dispatch(editContactSuccess()))
        .catch(() => {
            dispatch(editContactFailure(projectIndex, oldContact, contactIndex));
            dispatch(addAlert("Kunne ikke gemme redigeringen af kontaktperson"))
        })
    };
}


export const CREATE_CONTACT_REQUEST = 'CREATE_CONTACT_REQUEST';
export const createContactRequest = (projectIndex, contact) =>{
    return {
        type: CREATE_CONTACT_REQUEST,
        projectIndex: projectIndex,
        contact: contact
    }
}

export const CREATE_CONTACT_SUCCESS = 'CREATE_CONTACT_SUCCESS';
export const createContactSuccess = (projectIndex, id) =>{
    return {
        type: CREATE_CONTACT_SUCCESS,
        id: id,
        projectIndex: projectIndex
    }
}

export const CREATE_CONTACT_FAILURE = 'CREATE_CONTACT_FAILURE';
export const createContactFailure = (projectIndex) =>{
    return {
        type: CREATE_CONTACT_FAILURE,
        projectIndex: projectIndex
    }
}

export function createContact(projectIndex, projectId, contact){
    var _url = process.env.REACT_APP_webApiEndPoint + "api/project/"+projectId+"/addcontact";
    return dispatch => {
        var tempContact = contact;
        tempContact.id = Math.random().toString()
        dispatch(createContactRequest(projectIndex, tempContact));
        return httpPut(_url, contact)
        .then(response => {
            return response.json();
        })
        .then((json) => dispatch(createContactSuccess(projectIndex, json)))
        .catch(() => {
            dispatch(createContactFailure(projectIndex));
            dispatch(addAlert("Kunne ikke gemme kontaktperson"))
        })
    };
}


export const TOGGLE_FAVORITE = 'TOGGLE_FAVORITE';
export const toggleFavorite = (projectIndex,favorite) =>{
    return {
        type: TOGGLE_FAVORITE,
        projectIndex: projectIndex,
        favorite: favorite
    }
}

export function updateFavorite(projectIndex, projectId, favorite){
    var _url = process.env.REACT_APP_webApiEndPoint + "api/user/favorite/"+projectId;
    return dispatch => {
        dispatch(toggleFavorite(projectIndex,favorite))
        return httpPut(_url)
        .then(response => {
            return response;
        })
        .catch(() => {
            dispatch(toggleFavorite(projectIndex, !favorite));
        })
    };
}


export const UPDATE_PROJECT_SUMMARY = 'UPDATE_PROJECT_SUMMARY';
export const updateProjectSummary = (projectId, summary) =>{
    return (dispatch, getState) => {
        let projectIndex;
        getState().projectDashboardReducer.projects.forEach((project, index) => {
            if(project.id===projectId){
                projectIndex = index;
            }
        })
        //if the project index is found, dispatch the action
        if(projectIndex || projectIndex===0){
            dispatch({
                type: UPDATE_PROJECT_SUMMARY,
                projectIndex: projectIndex,
                summary: summary
            })
        }

    }

}


// WEBPACK FOOTER //
// ./src/App/Project/Dashboard/actions.js